
<template>
    <div class="center">
        <editar v-model="activeEditar" :selectInfo="selectInfo" :codigosDetalle="codigosDetalle" :ciclosEscolaresArray="ciclosEscolaresArray" :institucionesArray="institucionesArray" @refreshTable="getRefresh"></editar>
        <eliminar v-model="activeEliminar" :selectInfo="selectInfo" @refreshTable="getRefresh"></eliminar>
        <vs-table>
            <template #thead>
                <vs-tr>
                    <vs-th width="30%">
                        Académico
                    </vs-th>
                    <vs-th width="30%">
                        Código de detalle
                    </vs-th>
                    <vs-th width="30%">
                        Categoría
                    </vs-th>
                    <vs-th width="10%">
                        
                    </vs-th>
                </vs-tr>
            </template>
            <template #tbody>
                <vs-tr
                    :key="i"
                    v-for="(tr, i) in info"
                    :data="tr"
                >
                    <vs-td>
                        <p class="mb-0"><small>INSTITUCIÓN</small></p>
                        <p><strong>{{tr.institucion}}</strong></p>
                        <p class="mb-0"><small>CICLO ESCOLAR</small></p>
                        <p><strong>{{tr.ciclo_escolar}}</strong></p>
                    </vs-td>
                    <vs-td>
                        <p ><strong>{{tr.codigo_detalle}}</strong></p>
                    </vs-td>
                    <vs-td>
                        <p><strong>{{tr.nombre}}</strong></p>
                    </vs-td>
                    <vs-td>
                        <div class="d-flex">
                           <vs-button
                                flat
                                success
                                @click="activeEditar =! activeEditar, selectInfo = tr"
                            >
                                Editar
                            </vs-button>
                            <vs-button
                                flat
                                danger
                                @click="activeEliminar =! activeEliminar, selectInfo = tr"
                            >
                                Eliminar
                            </vs-button> 
                        </div>
                        
                    </vs-td>
                </vs-tr>
            </template>
            <template #notFound>
                Sin información
            </template>

        </vs-table>
    </div>
</template>
<script>
import editar from './modal/editar.vue'
import eliminar from './modal/eliminar.vue'
export default {
    props: [
        'info',
        'ciclosEscolaresArray',
        'institucionesArray',
        'filtros',
        'codigosDetalle'
    ],
    data:() => ({
        search: '',
        activeEditar: false,
        activeEliminar: false,
        selectInfo: []
    }),
    components: {
        editar,
        eliminar
    },
    methods:{
        getRefresh(){
            this.$emit('refreshTable')
        },
        getColor(metodo){
            if(metodo == 'servicio'){
                return 'bpill--servicio'
            }
            if(metodo == 'porcentaje'){
                return 'bpill--porcentaje'
            }
            if(metodo == 'monto'){
                return 'bpill--monto'
            }

        },
    },
}
</script>
<style lang="scss" scoped>
.fs-14 {
    font-size: 14px;
}
.figma-table {
    .bpill {
        color: white;
        width: 40px;
        height: 40px;
        flex-shrink: 0;
    }

    .bpill--servicio {
        background-color: purple;
    }

    .bpill--porcentaje {
        background-color: #5dade2;
    }

    .bpill--monto {
        background-color: #f39c12;
    }

    thead th {
        padding: 20px;
    }

    thead th:first-child {
        border-top-left-radius: 20px;
        width: 180px;
    }

    thead th:nth-child(2) {
        width: 320px;
    }

    thead th:last-child {
        border-top-right-radius: 20px;
    }

    .apill {
        min-width: 150px;
    }

    .apill--reingreso {
        background-color: #baece6;
        color: #16beaa;
    }

    .apill--ingreso {
        background-color: #ffeed4;
        color: #ffa928;
    }

    .fbutton {
        border: none;
        width: 35px;
        height: 35px;
    }

    .fbutton--edit {
        background-color: #e3f7e2;
        color: #65cd65;
    }

    .fbutton--delete {
        background-color: #ffe4e6;
        color: #ff4757;
    }
}
</style>


        